import api from './api';

export type TipoLei = 'LOA' | 'CREDITO_ADICIONAL';

export interface LeiOrcamentaria {
  id: string;
  tipo: TipoLei;
  exercicio: number;
  numero: string;
  descricao?: string | null;
  url: string;
  ativo: boolean;
  emendasVinculadas: number;
  atualizadoPor?: string | null;
  atualizadoEm?: string | null;
}

export interface LeiOrcamentariaPayload {
  tipo: TipoLei;
  exercicio: number;
  numero: string;
  descricao?: string;
  url: string;
}

const base = '/leis-orcamentarias';

const listar = async (params?: { exercicio?: number; somenteAtivas?: boolean }): Promise<LeiOrcamentaria[]> => {
  const response = await api.get(base, { params });
  return Array.isArray(response.data) ? response.data : [];
};

const criar = async (payload: LeiOrcamentariaPayload): Promise<LeiOrcamentaria> =>
  (await api.post(base, payload)).data;

const atualizar = async (id: string, payload: LeiOrcamentariaPayload): Promise<LeiOrcamentaria> =>
  (await api.put(`${base}/${id}`, payload)).data;

const definirAtivo = async (id: string, ativo: boolean): Promise<LeiOrcamentaria> =>
  (await api.patch(`${base}/${id}/ativo`, { ativo })).data;

export const TIPO_LEI_LABEL: Record<string, string> = {
  LOA: 'Lei Orçamentária Anual (LOA)',
  CREDITO_ADICIONAL: 'Crédito adicional',
};

export default { listar, criar, atualizar, definirAtivo };
